/**
 * Cross-section navigation helper.
 *
 * Called from Склад / Поступления / Инвентаризация rows to jump straight
 * into the "Товары" section with a specific product's edit modal open.
 *
 * Mechanism:
 *   1. Stash product id in sessionStorage (survives the section switch but
 *      not a full page reload — self-clearing).
 *   2. Dispatch `admin:navigate` — Admin.jsx listens and calls setSection.
 *   3. AdminProducts.jsx picks the id up on mount and opens the edit modal.
 */
export function openAdminProductEdit(productId) {
  if (!productId) return;
  try { sessionStorage.setItem("adminEditProductId", productId); } catch { /* noop */ }
  window.dispatchEvent(new CustomEvent("admin:navigate", { detail: { section: "products" } }));
}

/**
 * Open the public product page in a new tab.
 * Client app route is `/app/catalog/:id` (see App.js).
 */
export function openPublicProduct(productId) {
  if (!productId) return;
  window.open(`/app/catalog/${productId}`, "_blank", "noopener,noreferrer");
}
